import auth from "../middleware/auth";
import hasRCUser from "../middleware/library/hasRCUser";
import authorExists from "../middleware/library/authorExists";
import unAuthOrRCUser from "../middleware/library/unAuthOrRCUser";
import resourceExists from "../middleware/library/resourceExists";
import collectionExists from "../middleware/library/collectionExists";
import userMustChangePasswordCheck from "../middleware/userMustChangePasswordCheck";
import { useAuthUserStore } from "@/stores/authUser";
import { useRoute } from "vue-router";
import { useCollectionStore, useResourceStore, useAuthorStore } from "@/stores/models/resourceCenter";

export default [
    {
        path: "/library",
        name: "library.home",
        component: () => {
            return import(
                 "@/projects/library/App.vue"
            );
        },
        meta: {
            middleware: [userMustChangePasswordCheck],
            authIncludes: ["user.rcuser"],
            breadcrumb: null
        },
        children: [
            {
                path: "",
                name: "library.community",
                components: {
                    subview: () => {
                        return import(
                             "@/projects/library/views/Community.vue"
                        );
                    }
                },
                meta: {
                    title: "library.community.title",
                    middleware: [unAuthOrRCUser],
                    breadcrumb() {
                        return { label: this.$t("library.community.title") };
                    }
                }
            },
            {
                path: "created",
                name: "library.created",
                components: {
                    subview: () => {
                        return import(
                             "@/projects/library/views/Created.vue"
                        );
                    }
                },
                meta: {
                    title: "library.created.title",
                    middleware: [auth(), hasRCUser],
                    breadcrumb() {
                        return {
                            label: this.$t("library.created.title")
                        };
                    }
                }
            },
            {
                path: "author/:authorId/resources",
                name: "library.authorresources",
                props: true,
                components: {
                    subview: () => {
                        return import(
                             "@/projects/library/views/AuthorResources.vue"
                        );
                    }
                },
                meta: {
                    title: "library.authorresources.title",
                    middleware: [authorExists],
                    breadcrumb() {
                        const {params } = useRoute();
                        const authorStore = useAuthorStore();
                        let r = authorStore.item(params.authorId);

                        return {
                            label: r.display_name,
                            parent: "library.community"
                        };
                    }
                }
            },
            {
                path: "author/:authorId/collections",
                name: "library.authorcollections",
                props: true,
                components: {
                    subview: () => {
                        return import(
                             "@/projects/library/views/AuthorCollections.vue"
                        );
                    }
                },
                meta: {
                    title: "library.authorcollections.title",
                    middleware: [authorExists],
                    breadcrumb() {
                        const { params } = useRoute();
                        const authorStore = useAuthorStore();
                        let r = authorStore.item(params.authorId);

                        return {
                            label: r.display_name,
                            parent: "library.community"
                        };
                    }
                }
            },
            {
                path: "collections",
                name: "library.collections",
                components: {
                    subview: () => {
                        return import(
                             "@/projects/library/views/Collection.vue"
                        );
                    }
                },
                meta: {
                    title: "library.collection.title",
                    middleware: [],
                    breadcrumb() {
                        return {
                            label: this.$t("library.authorcollections.title")
                        };
                    }
                }
            },
            {
                path: "collections/:collectionId/resource/:resourceId",
                props: true,
                name: "library.collectionresources.resource",
                components: {
                    subview: () => {
                        return import(
                             "@/projects/library/views/ShowResource.vue"
                        );
                    }
                },
                meta: {
                    title: "library.showresource.title",
                    middleware: [collectionExists, resourceExists],
                    breadcrumb() {
                        const { params } = useRoute();
                        const resourceStore = useResourceStore();
                        let r = resourceStore.item(params.resourceId);

                        return {
                            label: r.title,
                            parent: "library.collectionresources"
                        };
                    }
                }
            },
            {
                path: "collections/:collectionId",
                name: "library.collectionresources",
                props: true,
                components: {
                    subview: () => {
                        return import(
                             "@/projects/library/views/CollectionResources.vue"
                        );
                    }
                },
                meta: {
                    title: "library.collectionresources.title",
                    middleware: [collectionExists],
                    breadcrumb() {
                        const { params } = useRoute();
                        const collectionStore = useCollectionStore();
                        let c = collectionStore.item(params.collectionId);

                        return {
                            label: c.title,
                            parent: "library.collections"
                        };
                    }
                }
            },
            {
                path: "liked",
                name: "library.liked",
                components: {
                    subview: () => {
                        return import(
                             "@/projects/library/views/Liked.vue"
                        );
                    }
                },
                meta: {
                    title: "library.liked.title",
                    middleware: [auth(), hasRCUser],
                    breadcrumb() {
                        return { label: this.$t("library.liked.title") };
                    }
                }
            },
            {
                path: "assigned",
                name: "library.assigned",
                components: {
                    subview: () => {
                        return import(
                             "@/projects/library/views/Assigned.vue"
                        );
                    }
                },
                meta: {
                    title: "library.assigned.title",
                    middleware: [auth()],
                    breadcrumb() {
                        return {
                            label: this.$t("library.assigned.title")
                        };
                    }
                }
            },
            {
                path: "create",
                props: true,
                components: {
                    subview: () => {
                        return import(
                             "@/projects/library/views/EditResource.vue"
                        );
                    }
                },
                meta: {
                    middleware: [auth(), hasRCUser]
                },
                children: [
                    {
                        path: "",
                        name: "library.create.new",
                        components: {
                            editview: () => {
                                return import(
                                     "@/projects/library/views/CreateResource.vue"
                                );
                            }
                        },
                        meta: {
                            title: "library.createresource"
                        }
                    },
                    {
                        path: "edit/:resourceId",
                        name: "library.create.edit",
                        components: {
                            editview: () => {
                                return import(
                                     "@/projects/library/views/CreateResource.vue"
                                );
                            }
                        },
                        meta: {
                            middleware: [resourceExists],
                            title: "library.editresource"
                        }
                    },
                    {
                        path: "copy/:resourceId",
                        name: "library.create.copy",
                        components: {
                            editview: () => {
                                return import(
                                     "@/projects/library/views/CreateResource.vue"
                                );
                            }
                        },
                        meta: {
                            middleware: [resourceExists],
                            title: "library.copyresource"
                        }
                    },
                    {
                        path: ":attachmentType",
                        components: {
                            editview: () => {
                                return import(
                                     "@/projects/library/views/Media.vue"
                                );
                            }
                        },
                        meta: {
                            middleware: [auth()]
                        },
                        children: [
                            {
                                path: "",
                                name: "library.create.media.choose",
                                components: {
                                    mediasubview: () => {
                                        return import(
                                             "@/projects/library/views/media/ChooseMediaView.vue"
                                        );
                                    }
                                },
                                meta: {
                                    title: "library.addmedia.mylibrary"
                                }
                            },
                            {
                                path: "photo",
                                name: "library.create.media.photo",
                                components: {
                                    mediasubview: () => {
                                        return import(
                                             "@/projects/library/views/media/AddPhotoView.vue"
                                        );
                                    }
                                },
                                meta: {
                                    title: "library.addphotoview.title"
                                }
                            },
                            {
                                path: "video",
                                name: "library.create.media.video",
                                components: {
                                    mediasubview: () => {
                                        return import(
                                             "@/projects/library/views/media/AddVideoView.vue"
                                        );
                                    }
                                },
                                meta: {
                                    title: "library.addvideoview.title"
                                }
                            },
                            {
                                path: "link",
                                name: "library.create.media.link",
                                components: {
                                    mediasubview: () => {
                                        return import(
                                             "@/projects/library/views/media/AddLinkView.vue"
                                        );
                                    }
                                },
                                meta: {
                                    title: "library.addlinkview.title"
                                }
                            },
                            {
                                path: "upload",
                                name: "library.create.media.upload",
                                components: {
                                    mediasubview: () => {
                                        return import(
                                             "@/projects/library/views/media/AddUploadView.vue"
                                        );
                                    }
                                },
                                meta: {
                                    title: "library.adduploadview.title"
                                }
                            },
                            {
                                path: "files",
                                name: "library.create.media.files",
                                components: {
                                    mediasubview: () => {
                                        return import(
                                             "@/projects/library/views/media/AddFilesView.vue"
                                        );
                                    }
                                },
                                meta: {
                                    title: "library.addfilesview.title"
                                }
                            }
                        ]
                    }
                ]
            },
            {
                path: "resource/:resourceId",
                props: true,
                name: "library.resource",
                components: {
                    subview: () => {
                        return import(
                             "@/projects/library/views/ShowResource.vue"
                        );
                    }
                },
                meta: {
                    title: "library.showresource.title",
                    middleware: [resourceExists],
                    breadcrumb() {
                        const { params } = useRoute();
                        const authUserStore = useAuthUserStore();
                        const resourceStore = useResourceStore();
                        let r = resourceStore.item(params.resourceId);

                        let p = r.published
                            ? "library.community"
                            : "library.created";
                        const u = authUserStore.user;
                        if (u && !u.related.rcuser) {
                            p = "library.assigned";
                        }

                        return {
                            label: r.title,
                            parent: p
                        };
                    }
                }
            }
        ]
    }
];
